<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",

  methods: {
    handle(tag) {
      this.apipost(
        "/api/Trade/GetFirstShopEnrollResultUrl",
        {
          UserFlag: tag,
        },
        (res) => {
          if (res.data.resultCode == 1) {
            if (res.data.data) {
              localStorage.removeItem("fujianTag");
              clearInterval(this.timer);
              localStorage.setItem("fujianUrl", res.data.data);
              this.$confirm("有下载文件准备完成, 前往下载?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "info",
              }).then(() => {
                this.$router.push("/billboardList");
              });
            }
          } else {
            this.$message.error(res.data.message);
          }
        }
      );
    },
  },
  mounted() {
    let tag = localStorage.getItem("fujianTag");
    let that = this;
    if (tag) {
      this.timer = setInterval(() => {
        setTimeout(() => {
          that.handle(tag);
        }, 0);
      }, 10000);
    }
  },
  destroyed() {
    clearInterval(this.timer);
  },
};
</script>

<style>
@import "//at.alicdn.com/t/font_1769104_jv28qwhjime.css";
@import "./assets/css/common.css";
@import "./assets/css/zkcss.css";
html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
#app {
  height: 100%;
}
/*滚动条样式*/
::-webkit-scrollbar {
  /*滚动条整体样式*/
  height: 5px;
  width: 4px;
  border-radius: 5px;
}
::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 5px !important;
  background: #b5b5b5 !important;
}
::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 0 rgba(0, 0, 0, 0.2) !important;
  border-radius: 20px !important;
  background: transparent !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue